// storage 存储key
export const STORAGE = {
	LGN_STATUS: {
		value: 'ttn-cache-service-login-status',
		desc: '登录状态',
	},
	LGN_ACTIVE_URL: {
		value: 'ttn-cache-service-active-url',
		desc: '激活的URL',
	},
	SESSION_INFO: {
		value: 'ttn-cache-session-info',
		desc: '登录后获取的session信息',
	},
	LGN_TAB_INFO: {
		value: 'ttn-cache-service-lgn-tab-info',
		desc: 'tab页面状态',
	},
	LGN_TOKEN_INFO: {
		value: 'ttn-cache-lgn-token-info',
		desc: 'token',
	},
	MENU_INFO: {
		value: 'ttn-cache-service-menu-info',
		desc: '菜单列表',
	},
	REDUX_INFO: {
		value: 'persist:ttn-cache-service-redux-info',
		desc: 'redux',
	},
};
